const MODULE_BASE = `${process.env.REACT_APP_PATH_MAP_BASE}/cal-essdocs`

const ESSDOCS_SSO_PATH = `${MODULE_BASE}/sso`

const pathMap = {
  ESSDOCS_SSO: ESSDOCS_SSO_PATH,
}

export default pathMap
